var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEncuentra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.237,
    height: 107.199,
    viewBox: "0 0 107.237 107.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(-421.598 -549.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(423.389 551.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M508.88,626.91l30.381,30.382a7.152,7.152,0,0,1-10.115,10.115l-30.382-30.382Z",
    transform: "translate(-437.698 -565.843)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M506.005,593.047a41.11,41.11,0,0,1-41.1,41.1c-.911,0-1.805-.036-2.681-.089a41.1,41.1,0,0,1,0-82.031c.876-.054,1.769-.09,2.681-.09A41.11,41.11,0,0,1,506.005,593.047Z",
    transform: "translate(-423.797 -551.942)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_81",
    "data-name": "Elipse 81",
    cx: 38.424,
    cy: 41.015,
    rx: 38.424,
    ry: 41.015,
    transform: "translate(0 0.09)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M500.484,594.674a33.963,33.963,0,0,1-33.955,33.955c-.894,0-1.805-.036-2.681-.107a33.955,33.955,0,0,1,0-67.7c.876-.072,1.787-.107,2.681-.107A33.964,33.964,0,0,1,500.484,594.674Z",
    transform: "translate(-425.424 -553.569)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_82",
    "data-name": "Elipse 82",
    cx: 31.275,
    cy: 33.848,
    rx: 31.275,
    ry: 33.848,
    transform: "translate(7.149 7.256)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M489.442,603.9v13.081a1.792,1.792,0,0,1-1.787,1.787H451.911a1.792,1.792,0,0,1-1.787-1.787V603.9Z",
    transform: "translate(-428.679 -561.576)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M484.08,603.9v13.081a1.792,1.792,0,0,1-1.787,1.787H451.911a1.792,1.792,0,0,1-1.787-1.787V603.9Z",
    transform: "translate(-428.679 -561.576)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M490.822,588.833v8.722a3.791,3.791,0,0,1-3.789,3.789H451.719a3.791,3.791,0,0,1-3.789-3.789v-8.722a1.793,1.793,0,0,1,1.787-1.787h39.317A1.793,1.793,0,0,1,490.822,588.833Z",
    transform: "translate(-428.272 -558.451)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M485.461,588.833v8.722a3.79,3.79,0,0,1-3.789,3.789H451.719a3.791,3.791,0,0,1-3.789-3.789v-8.722a1.793,1.793,0,0,1,1.787-1.787h33.955A1.793,1.793,0,0,1,485.461,588.833Z",
    transform: "translate(-428.272 -558.451)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M505.709,645.8l24.725,24.725a7.165,7.165,0,0,0,7.738,1.57,7.1,7.1,0,0,1-2.377-1.57l-26.786-26.786C507.948,644.485,506.84,645.161,505.709,645.8Z",
    transform: "translate(-438.986 -568.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    "data-name": "Trazado 332",
    d: "M462.22,634.062c.876.053,1.769.089,2.681.089.867,0,1.724-.048,2.578-.1a41.1,41.1,0,0,1,.064-82.014c-.875-.055-1.754-.094-2.642-.094-.911,0-1.805.036-2.681.09a41.1,41.1,0,0,0,0,82.031Z",
    transform: "translate(-423.797 -551.942)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(421.598 549.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    "data-name": "Trazado 333",
    d: "M504.15,642.187l16.427,16.427,10.362,10.362-2.527,2.527-10.362-10.36-16.427-16.429Z",
    transform: "translate(-436.437 -566.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    d: "M464.493,635.54a42.617,42.617,0,0,0,23.324-6.925l4.022,4.022a1.787,1.787,0,0,0,2.528-2.528l-3.6-3.6a43.269,43.269,0,0,0,7.588-7.588l25.332,25.331a5.373,5.373,0,0,1,0,7.588,5.5,5.5,0,0,1-7.588,0h0l-11.624-11.624a1.787,1.787,0,0,0-2.528,2.528l11.623,11.623,0,0a8.94,8.94,0,0,0,12.643-12.644L500.46,615.973a42.873,42.873,0,1,0-35.967,19.567Zm0-82.209a39.317,39.317,0,1,1-39.317,39.318A39.317,39.317,0,0,1,464.493,553.331Z",
    transform: "translate(-421.598 -549.792)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    d: "M466.122,630.01a35.743,35.743,0,1,0-35.743-35.743A35.743,35.743,0,0,0,466.122,630.01Zm0-67.912a32.169,32.169,0,1,1-32.168,32.169A32.169,32.169,0,0,1,466.122,562.1Z",
    transform: "translate(-423.226 -551.411)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    d: "M514.836,653.983a1.363,1.363,0,0,0-.342.114,1.113,1.113,0,0,0-.3.152,2.567,2.567,0,0,0-.278.227,1.872,1.872,0,0,0-.53,1.263,1.762,1.762,0,0,0,2.476,1.643,1.788,1.788,0,0,0-.682-3.437Z",
    transform: "translate(-438.618 -569.105)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    d: "M447.524,599.585v12.233a3.578,3.578,0,0,0,3.574,3.575h35.743a3.579,3.579,0,0,0,3.574-3.575V599.585a5.547,5.547,0,0,0,1.787-4.067V586.8a3.579,3.579,0,0,0-3.574-3.574H481.48V579.65a3.578,3.578,0,0,0-3.574-3.574H460.034a3.579,3.579,0,0,0-3.574,3.574v3.574h-7.148a3.578,3.578,0,0,0-3.574,3.574v8.719A5.54,5.54,0,0,0,447.524,599.585Zm39.317,12.233H451.1V601.074c.073,0,.143.022.217.022h15.868v1.787a1.787,1.787,0,0,0,3.574,0V601.1h15.868c.074,0,.143-.02.217-.022v10.744ZM460.034,579.65h17.872v3.574H460.034V579.65ZM449.311,586.8h39.318v8.719a2.007,2.007,0,0,1-2,2h-35.31a2.007,2.007,0,0,1-2-2V586.8Z",
    transform: "translate(-426.074 -554.666)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    "data-name": "Trazado 338",
    d: "M543.128,671.268a1.813,1.813,0,1,0-1.269.518A1.885,1.885,0,0,0,543.128,671.268Z",
    transform: "translate(-443.562 -571.741)",
    fill: "#264ecc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEncuentra);
export default __webpack_public_path__ + "static/media/icon-encuentra.5945e0c46592fab7d69bfef681716343.svg";
export { ForwardRef as ReactComponent };